import { render, staticRenderFns } from "./TrendyolProductHome.vue?vue&type=template&id=49b84b0b&"
import script from "./TrendyolProductHome.vue?vue&type=script&lang=js&"
export * from "./TrendyolProductHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports